import React, {Component} from 'react';
import {  connect } from 'react-redux';
import {Route, Switch} from "react-router";
import { withRouter } from 'react-router'
import LoginHOC from '../login/loginHOC';
import LayoutHOC from "../layout/layoutHOC";

class InitialRouter extends Component {
  render(){
    let baseRouteComponent ;
    if(this.props.isLoggedIn) baseRouteComponent = <Route path="/" component={ (props) =>  <LayoutHOC {...props}/> }/>;
    else baseRouteComponent = <Route path="/" component={(props) =>  <LoginHOC {...props}/>} />;
    return (
      <div>
        <Switch>
          {baseRouteComponent}
        </Switch>
      </div>
    )
  }
};

const mapStateToProps = (state) => {
  return {
    isLoggedIn: state.loggedInPerson.get('id')
  }
};

const mapDispatchToProps = (dispatch) => {
  return {}
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InitialRouter));



// WEBPACK FOOTER //
// ./src/components/routers/initialRouter.js